import { Component, Input, OnInit, ViewChild } from "@angular/core";
import {
  DataStateChangeEventArgs,
  GridComponent,
} from "@syncfusion/ej2-angular-grids";
import { ToastrService } from "ngx-toastr";
import { Observable, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { GlobalComponent } from "src/app/global/global.component";
import { ColumnChangeBO, columnWidth } from "../../icd10/icd10.model";
import { AuthorizationUtilizationBO, ClientAuthorizationReportBo, PageIdentifyBo, UtilizationBO } from "../client-parent.model";
import { ClientAuthorizationReportService } from "./client-authorization-report.service";
import { CommonApiService } from "src/app/commonapiservice";

@Component({
  selector: "app-client-authorization-report",
  templateUrl: "./client-authorization-report.component.html",
  styleUrls: ["./client-authorization-report.component.scss"],
})
export class ClientAuthorizationReportComponent implements OnInit {
  @ViewChild("gridAuthorization") public gridAuthorization: GridComponent;
  @ViewChild("gridUtilizationStatus") public gridUtilizationStatus: GridComponent;
  @Input() HousingorEmployement = new PageIdentifyBo();
  id: number = 0;
  isUtilization:boolean=false;
  AuthorizationReporttype: string;
  initialPage: object;
  UtilizationListType: UtilizationBO = new UtilizationBO();
  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];
  private onDestroy$: Subject<void> = new Subject<void>();
  public dataAuthorizationReport: Observable<DataStateChangeEventArgs>;
  public dataUnderOver: Observable<DataStateChangeEventArgs>;
  arraycol: any = [];
  UtilizationList: any = [];
  AuthorizationList: any = [];
  isEnabledExcel: boolean = false;
  isCheckGenerate: boolean = false;
  columnchange: ColumnChangeBO = new ColumnChangeBO();
  ColumnArrayData: columnWidth[];
  public formatDateandTimeOptions: object;
  filterSettings: object;
  public formatOptions: object;
  UtilizationDateFilterType: string = "CURRENTDATE"
  initialUtilizationPage: object;
  pageitem: any;
  AuthorizationReportBo: ClientAuthorizationReportBo =
    new ClientAuthorizationReportBo();
  AUBO: AuthorizationUtilizationBO = new AuthorizationUtilizationBO();
  utilizationType: string = "";
  constructor(
    public CommonAPI: CommonApiService,
    public global: GlobalComponent,
    public toastrService: ToastrService,
    public AuthorizationReportService: ClientAuthorizationReportService
  ) {
    this.dataAuthorizationReport = AuthorizationReportService;
    this.dataUnderOver = CommonAPI;
  }
  locationId: string = "00000000-0000-0000-0000-000000000000";
  ngOnInit(): void {
    this.filterSettings = { type: "Menu" };
    this.formatOptions = { type: "date", format: "MM/dd/yyyy" };
    let pag = 10;
    this.initialPage = { pageSizes: ['10', '15', '20', '50', '100', '250'], pageSize: pag }
    this.AuthorizationReportBo.pageitem = pag;
    if (
      this.global.globalLocationId != null &&
      this.global.globalLocationId != undefined &&
      this.global.globalLocationId != ""
    ) {
      this.locationId = this.global.globalLocationId;
    } else {
      this.locationId = "00000000-0000-0000-0000-000000000000";
    }
    // this.getServiceTypes();
    this.getAuthorizationReportFilter();
  }
  //..........................................For getServiceTypes.........................................
  getServiceTypes() {
    let url = "api/LOV/getLovDropDown?"
    let params = new URLSearchParams();
    params.append("ListCode", "SERVICETYPE");
    this.CommonAPI.getDropDownList('SERVICETYPE', params, url, "LovDropDown").then((data: any) => {
      this.global.serviceType = data;
 
      if (!this.HousingorEmployement.isHousing) {
        this.HousingorEmployement.PageTypeLid = this.global.serviceType?.filter(
          (st) => st.lovName == "HOMECARE"
        )[0].id;
        this.UtilizationListType.serviceTypeLid= this.HousingorEmployement.PageTypeLid;
        this.getAuthorizationReportFilter();
      }
      else {
        this.UtilizationListType.serviceTypeLid= this.HousingorEmployement.PageTypeLid;
        this.getAuthorizationReportFilter();
      }
    })
  }
  //..........................................onComplete.........................................
  public onComplete(args) {
    this.AuthorizationReportBo.currentpageno =
      this.gridAuthorization.pagerModule.pagerObj.currentPage;
    this.AuthorizationReportBo.pageitem =
      this.gridAuthorization.pagerModule.pagerObj.pageSize;
    if (args.name == "actionBegin" && args.requestType == "filterbeforeopen") {
      this.AuthorizationReportBo.type = args.columnType;
    }
    if (args.requestType == "columnstate") {
      let hidearr = [];
      let showarr = [];
      this.gridAuthorization.columns.forEach((element) => {
        if (
          element.visible == false &&
          element.headerText != "Actions" &&
          element.headerText != ""
        ) {
          hidearr.push(element.headerText);
        }
        if (
          element.visible == true &&
          element.headerText != "Actions" &&
          element.headerText != ""
        ) {
          showarr.push(element.headerText);
        }
      });
      var count = 0;
      var count1 = 0;
      if (args.columns.length > 0) {
        this.arraycol[0].AuthorizationReport.ShowColumns.forEach((old) => {
          showarr.forEach((element) => {
            if (old == element) {
              count1 = count1 + 1;
            }
          });
        });
        this.arraycol[0].AuthorizationReport.HideColumns.forEach((old) => {
          hidearr.forEach((element) => {
            if (old == element) {
              count = count + 1;
            }
          });
        });
        if (
          this.arraycol[0].AuthorizationReport.ShowColumns.length != count1 ||
          this.arraycol[0].AuthorizationReport.HideColumns.length != count
        ) {
          this.arraycol[0].AuthorizationReport.ShowColumns = showarr;
          this.arraycol[0].AuthorizationReport.HideColumns = hidearr;
        //   this.SaveColumnwidth();
        }
      }
    }
  }
  //..........................................dataStateChange........................................
  public dataStateChange(state): void {
    this.AuthorizationReporttype = state.action.requestType.toString();
    if (this.AuthorizationReporttype != "filterchoicerequest") {
      if ((state.sorted || []).length) {
        this.AuthorizationReportBo.orderColumn = state.sorted[0].name;
        this.AuthorizationReportBo.orderType =
          state.sorted[0].direction === "descending" ? "DESC" : "ASC";
      }
    }
    if (
      this.AuthorizationReporttype == "filtering" &&
      state.action.action != "clearFilter"
    ) {
      this.AuthorizationReportBo.field = state.action.currentFilterObject.field;
      this.AuthorizationReportBo.matchCase = false;
      this.AuthorizationReportBo.operator =
        state.action.currentFilterObject.operator;
      this.AuthorizationReportBo.value =
        state.action.currentFilterObject.value.toString();
    } else {
      if (
        this.AuthorizationReporttype == "filtering" &&
        state.action.action == "clearFilter"
      ) {
        this.AuthorizationReportBo.field = "clientName";
        this.AuthorizationReportBo.matchCase = false;
        this.AuthorizationReportBo.operator = "startswith";
        this.AuthorizationReportBo.value = "";
        this.AuthorizationReportBo.type = "string";
      }
    }
    if (
      this.AuthorizationReporttype == "paging" &&
      state.action.name == "actionBegin"
    ) {
      if (this.arraycol.length != 0) {
        if (this.arraycol[0].AuthorizationReport.Pagesize != state.take) {
          this.arraycol[0].AuthorizationReport.Pagesize = state.take;
        //   this.SaveColumnwidth();
        }
      }
    }

    this.getAuthorizationReportFilter();
  }
  //..........................................SaveColumnwidth.........................................
  SaveColumnwidth() {
    this.columnchange.userid = parseInt(this.global.userID);
    this.columnchange.column = JSON.stringify(this.arraycol);
    this.columnchange.id = this.id;
    this.global.globalColumn = this.columnchange;
    this.arraycol = JSON.parse(this.global.globalColumn.column);
    let url = "api/ColumnChange/Savewidth?";
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(this.columnchange, url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((data: any) => {
        // this.getColumnwidth();
      });
  }
  //..........................................getColumnwidth.........................................
  getColumnwidth() {
    this.arraycol = JSON.parse(this.global.globalColumn.column);
    this.ColumnArrayData = this.arraycol[0].AuthorizationReport.Columns;
    let hidecol = this.arraycol[0].AuthorizationReport.HideColumns;
    // this.gridAuthorization.hideColumns(hidecol);
    if (
      this.global.globalColumn.userid != null &&
      this.global.globalColumn.agencyId != null
    ) {
      this.id = this.global.globalColumn.id;
    }
    this.gridAuthorization.pageSettings.pageSize =
      this.arraycol[0].AuthorizationReport.Pagesize;
    this.ColumnArrayData.forEach((element) => {
      if (element.column == "ClientName") {
        const column = this.gridAuthorization.getColumnByField("clientName");
        column.width = element.width;
        this.gridAuthorization.refreshHeader();
      }

      if (element.column == "StartDate") {
        const column1 = this.gridAuthorization.getColumnByField("startDate");
        column1.width = element.width;
        this.gridAuthorization.refreshHeader();
      }
      if (element.column == "HousingCoordinator") {
        const column1 = this.gridAuthorization.getColumnByField("hcName");
        column1.width = element.width;
        this.gridAuthorization.refreshHeader();
      }

      if (element.column == "EndDate") {
        const column = this.gridAuthorization.getColumnByField("endDate");
        column.width = element.width;
        this.gridAuthorization.refreshHeader();
      }
      if (element.column == "Location") {
        const column = this.gridAuthorization.getColumnByField("location");
        column.width = element.width;
        this.gridAuthorization.refreshHeader();
      }
      if (element.column == "Company") {
        const column = this.gridAuthorization.getColumnByField("company");
        column.width = element.width;
        this.gridAuthorization.refreshHeader();
      }
      if (element.column == "Payor") {
        const column = this.gridAuthorization.getColumnByField("payor");
        column.width = element.width;
        this.gridAuthorization.refreshHeader();
      }
      if (element.column == "Service") {
        const column = this.gridAuthorization.getColumnByField("serviceCode");
        column.width = element.width;
        this.gridAuthorization.refreshHeader();
      }
      if (element.column == "Service Description") {
        const column = this.gridAuthorization.getColumnByField("serviceDescription");
        column.width = element.width;
        this.gridAuthorization.refreshHeader();
      }
      if (element.column == "Total Units") {
        const column = this.gridAuthorization.getColumnByField("totalUnits");
        column.width = element.width;
        this.gridAuthorization.refreshHeader();
      }
       if (element.column == "Employee") {
        const column = this.gridAuthorization.getColumnByField("employeeNames");
        column.width = element.width;
        this.gridAuthorization.refreshHeader();
      }
      if (element.column == "Net Rate") {
        const column = this.gridAuthorization.getColumnByField("netRate");
        column.width = element.width;
        this.gridAuthorization.refreshHeader();
      }
      if (element.column == "Uc Rate") {
        const column = this.gridAuthorization.getColumnByField("ucRate");
        column.width = element.width;
        this.gridAuthorization.refreshHeader();
      }
      if (element.column == "Units Remaining") {
        const column =
          this.gridAuthorization.getColumnByField("unitsRemaining");
        column.width = element.width;
        this.gridAuthorization.refreshHeader();
      }
      if (element.column == "HoursPerDay") {
        const column = this.gridAuthorization.getColumnByField("hoursPerDay");
        column.width = element.width;
        this.gridAuthorization.refreshHeader();
      }
      if (element.column == "Remaining HoursPerDay") {
        const column = this.gridAuthorization.getColumnByField(
          "remainingHoursPerDay"
        );
        column.width = element.width;
        this.gridAuthorization.refreshHeader();
      }

      if (element.column == "Address") {
        const column = this.gridAuthorization.getColumnByField("address");
        column.width = element.width;
        this.gridAuthorization.refreshHeader();
      }

      if (element.column == "Email") {
        const column = this.gridAuthorization.getColumnByField("email");
        column.width = element.width;
        this.gridAuthorization.refreshHeader();
      }

      if (element.column == "Phone") {
        const column = this.gridAuthorization.getColumnByField("phone1");
        column.width = element.width;
        this.gridAuthorization.refreshHeader();
      }
    });

    let columns = "HousingCoordinator";

    if (!this.HousingorEmployement.isHousing) {
      this.gridAuthorization.hideColumns(columns);

    } else {
      if (this.HousingorEmployement.PageIdentity == "employmentservices") {
        this.gridAuthorization.hideColumns(columns);
      }
      else {
        this.gridAuthorization.showColumns(columns);
      }
    }
  }
  //..........................................showColumn.........................................
  showColumn() {
    this.gridAuthorization.columnChooserModule.openColumnChooser(200, 50);
  }
  //..........................................onResize........................................
  onResize(args) {
    if (this.ColumnArrayData != undefined && this.ColumnArrayData != null) {
      const column = this.gridAuthorization.getColumnByField(args.column.field);
      column.width = args.column.width;
      this.ColumnArrayData.forEach((element) => {
        if (element.column == column.headerText) {
          element.width = parseInt(column.width.toString());
        }
      });
    //   this.SaveColumnwidth();
    }
  }
  //..........................................getAuthorizationReportFilter.........................................
  getAuthorizationReportFilter() {
    this.AuthorizationReportBo.locationID = this.locationId;
    this.AuthorizationReportBo.isHousing = this.HousingorEmployement.isHousing;
    this.AuthorizationReportBo.serviceTypeLid = this.HousingorEmployement.PageTypeLid !=  "00000000-0000-0000-0000-000000000000" ? this.HousingorEmployement.PageTypeLid.toString() :"00000000-0000-0000-0000-000000000000" ;
    this.AuthorizationReportService.outputValuesAuthorizationReport(
      this.AuthorizationReportBo
    );
   
    this.dataAuthorizationReport
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((data: any) => {
        this.AuthorizationList = data.result;

        if (data.result.length > 15) {
          this.gridAuthorization.height = "500";
        } else {
          this.gridAuthorization.height = "auto";
        }
        if (data != null && data != undefined) {
        //   this.getColumnwidth();
        }
        if (data != null && data.result.length > 0) {
          this.isEnabledExcel = true;
        } else {
          this.isEnabledExcel = false;
        }
        this.isUtilization=true;
        this.UtilizationListType.isInsideClient=false;
        this.UtilizationListType.UtilizationLength= this.AuthorizationList;
      });
  }
  //..........................................exportClientAuthorizationReportCsv.........................................
  exportClientAuthorizationReportCsv() {
    let url: any = this.HousingorEmployement.isHousing ? "api/ClientAuthorization/ExportServiceTypeAuthorizationDetailsCsv" : "api/ClientAuthorization/exportClientAuthorizationDetailsCsv";
    let saveFileName = !this.HousingorEmployement.isHousing ? "ClientAuthorizationReport.csv" : this.HousingorEmployement.PageIdentity == "employmentservices" ? "EmploymentAuthorizationReport.csv" : "HousingAuthorizationReport.csv";
    this.CommonAPI.saveorUpdateFunctionFileSaver(
      this.AuthorizationReportBo, url, saveFileName
    );
  }
  //..........................................ngOnDestroy.........................................
  public ngOnDestroy(): void {
    this.onDestroy$.next();
  }
}
